import React, { useState, useEffect } from 'react';
import './closestMatch.scss';
import {
    diduMeanRelated,
    diduMeanRentals,
    customSearchBox,
    relinfos_searchbox_ctlr
} from '../../../controllers/searchresultscontroller';
import SearchResultsFound from './SearchResultsFound';

const QuerySummaryHeader = props => {
    const { searchTotalCount, term, showUnavailableItems } = props;
    const [didUMeanRental, setDidUMeanRental] = useState(diduMeanRentals.state);
    const [didUMeanRel, setDidUMeanRel] = useState(diduMeanRelated.state);

    const updateRentalState = () => {
        setDidUMeanRental(diduMeanRentals.state);
    };

    const updateRelState = () => {
        setDidUMeanRel(diduMeanRelated.state);
    };

    useEffect(() => {
        diduMeanRelated.subscribe(updateRelState);
        diduMeanRentals.subscribe(updateRentalState);
    }, []);

    useEffect(() => {
        if (didUMeanRental.wasAutomaticallyCorrected) {
            customSearchBox.updateText(didUMeanRental.queryCorrection.wordCorrections[0].originalWord);
            relinfos_searchbox_ctlr.updateText(didUMeanRental.queryCorrection.wordCorrections[0].originalWord);
        } else if (didUMeanRel.wasAutomaticallyCorrected) {
            customSearchBox.updateText(didUMeanRel.queryCorrection.wordCorrections[0].originalWord);
            relinfos_searchbox_ctlr.updateText(didUMeanRel.queryCorrection.wordCorrections[0].originalWord);
        }
    }, [didUMeanRental, didUMeanRel]);
    if (!(didUMeanRental.hasQueryCorrection || didUMeanRel.hasQueryCorrection)) {
        return term ? (
            <SearchResultsFound count={searchTotalCount} term={term} showUnavailableItems={showUnavailableItems} />
        ) : null;
    }
    return (
        <>
            <div className="searchresult">
                <div className="container">
                    <div className="searchresult__title searchresult__title--didyoumean">
                        No results for "
                        <b className="searchresult__term">
                            {didUMeanRental?.originalQuery || didUMeanRel?.originalQuery}
                        </b>
                        "
                    </div>
                    <div className="didyoumean-content">
                        Showing results for{' '}
                        <b>"{(didUMeanRental?.wasCorrectedTo || didUMeanRel?.wasCorrectedTo).replace('+', '')}"</b>
                    </div>
                </div>
            </div>
        </>
    );
};

export default QuerySummaryHeader;
